<template>
  <Select
    v-model="selectedUser"
    :options="users"
    option-label="label"
    filter
    :filter-fields="['name', 'email', 'label']"
    :placeholder="placeholder || $t('UserSelectInput.placeholder')"
    :invalid="invalid"
    :disabled="disabled || loading"
    :loading="loading"
    class="w-full"
    data-testid="user-select-input"
  >
    <template #option="slotProps">
      <div
        class="flex flex-col py-0.5"
        :data-user-email="slotProps.option.email || undefined"
      >
        <span class="text-[var(--color-dark)]">{{ slotProps.option.name || slotProps.option.label }}</span>
        <span
          v-if="slotProps.option.email"
          class="text-xs text-[var(--color-disabled)]"
        >
          {{ slotProps.option.email }}
        </span>
      </div>
    </template>
    <template #emptyfilter>
      <span class="text-sm text-[var(--color-disabled)]">{{ $t('UserSelectInput.empty') }}</span>
    </template>
    <template #empty>
      <span class="text-sm text-[var(--color-disabled)]">
        {{ loading ? $t('UserSelectInput.loading') : $t('UserSelectInput.empty') }}
      </span>
    </template>
  </Select>
</template>

<script>
import Select from 'primevue/select';
import NetworkContent from '@/helpers/networking/NetworkContent';
import { normalizeParticipantUsers } from '@/utils/userParticipants';

export default {
  name: 'UserSelectInput',
  components: {
    Select,
  },
  props: {
    modelValue: {
      type: String,
      default: '',
    },
    users: {
      type: Array,
      default: null,
    },
    placeholder: {
      type: String,
      default: '',
    },
    invalid: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['update:modelValue'],
  data() {
    return {
      localUsers: [],
      loading: false,
    };
  },
  computed: {
    resolvedUsers() {
      return this.users ?? this.localUsers;
    },
    selectedUser: {
      get() {
        return this.resolvedUsers.find((user) => user.id === this.modelValue) || null;
      },
      set(user) {
        this.$emit('update:modelValue', user?.id || '');
      },
    },
  },
  watch: {
    users: {
      immediate: true,
      handler(nextUsers) {
        if (nextUsers == null) {
          this.loadUsers();
        }
      },
    },
  },
  methods: {
    async loadUsers() {
      if (this.users != null || this.loading) return;
      this.loading = true;
      try {
        const { data } = await NetworkContent.getParticipants();
        this.localUsers = normalizeParticipantUsers(data?.users ?? []);
      } catch {
        this.localUsers = [];
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
